/* jshint esversion: 6 */

import React from 'react';
import PropTypes from 'prop-types';

class WebsiteWidgetPopout extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      show: false,
    };
  }

  componentDidMount() {
    if (this.popout) return;
    if (this.props.popoutText === null) return;

    this.popout = setTimeout(() => {
      this.setState({show: true});
      this.props.onPopout();
    }, 2000);
  }

  closePopout(e) {
    e.stopPropagation();
    this.setState({show: false}, this.props.onClose);
  }

  render() {
    if (this.props.disabled) {
      clearTimeout(this.popout);
      return null;
    }

    if (!this.state.show) return null;

    return (
      <div id="popout" className={this.state.show ? 'opening' : 'hide'} >
        <div className="arrow-box no-select">
          <div tabIndex="1" role="button" aria-label="chat pop up link" aria-hidden={this.state.show ? '' : 'true'} onClick={(e) => { this.props.onPopoutClick()}} onKeyDown={(e) => { if (e.key == " " || e.code == "Space" || e.keyCode == 32) { this.props.onPopoutClick() }} }>
            {this.props.popoutText}
          </div>
          <div id="close-popout" tabIndex="1"  role="button" aria-label="close chat tooltip" aria-hidden={this.state.show ? 'true' : ''} className="no-select" onClick={(e) => this.closePopout(e)} onKeyDown={(e) => { if (e.key == " " || e.code == "Space" || e.keyCode == 32) { this.closePopout(e) }} }>×</div>
        </div>
      </div>
    );
  }
}

WebsiteWidgetPopout.propTypes = {
  disabled: PropTypes.bool,
  popoutText: PropTypes.string,
  onPopout: PropTypes.func,
  onPopoutClick: PropTypes.func,
  onClose: PropTypes.func,
};

export default WebsiteWidgetPopout;
